import React from 'react';
import { useTranslation } from 'react-i18next';
import { UncontrolledTooltip, Row, Col } from 'reactstrap';
import moment from 'moment/min/moment-with-locales';
import { composeDisplayName } from '../../Helpers/applicantHelper';
import { Rating } from 'react-simple-star-rating';
import { basicDateFormat, basicDateTimeFormat } from '../../Helpers/dateTimeHelper';

const CommentsTimelineCard = ({
  comment,
  index,
  viewComment,
  editComment,
  deleteComment,
  goToApplicant,
  displayLatest,
  isDateDifferent,
  mode, // full, commentOnly
}) => {
  const { t } = useTranslation();

  return (
    <>
      {(mode === 'full' ? isDateDifferent(comment) : isDateDifferent(comment.created)) ? (
        <li
          className="timeline-separator"
          data-datetime={moment.utc(comment.created).local().format(basicDateFormat)}
        />
      ) : null}
      <li className={index % 2 === 1 ? 'timeline-inverted' : null}>
        <div className="timeline-badge success" id={`timelineCommentApplicationStatus-${index}`}>
          <em className="fa icon-note"></em>
          <UncontrolledTooltip
            delay={{ show: 200, hide: 0 }}
            placement="left"
            target={`timelineCommentApplicationStatus-${index}`}
          >
            {t('common.COMMENT')}
          </UncontrolledTooltip>
        </div>
        <div className="timeline-card">
          <div className="popover right">
            <h4 className="popover-header">
              <Row>
                <Col>
                  {/* <em className="fa mr-1 icon-note" /> */}
                  {displayLatest && (
                    <span
                      style={{
                        cursor: 'pointer',
                        textDecoration: 'underline',
                        color: 'blue',
                      }}
                      onClick={() => goToApplicant(comment.applicantId)}
                    >
                      {comment.applicantFirstName} {comment.applicantLastName}
                    </span>
                  )}{' '}
                  {comment.title}
                  <span className="text-sm text-muted"> - {composeDisplayName(comment)}</span>
                </Col>
                <Col xs="auto" className="d-flex flex-column align-items-end justify-content-center">
                  <Rating className="pr-1" initialValue={comment.rating} readonly={true} size={30} transition />
                  <span className="text-sm text-muted mt-1">
                    <i className="fa-regular fa-clock" />
                    &nbsp;
                    {moment.utc(comment.created).format(basicDateTimeFormat)}
                  </span>
                </Col>
              </Row>
            </h4>
            <div className="popover-body">
              <p
                dangerouslySetInnerHTML={{
                  __html: comment.message,
                }}
              />
            </div>
            <div className="popover-body">
              <em
                className="fa fa-eye far icon-hover-effect-no-color"
                style={{ cursor: 'pointer' }}
                id={`btnViewComment-${index}`}
                onClick={() => viewComment(comment)}
              />
              &nbsp;
              <em
                className="fa fa-pencil-alt far icon-hover-effect-no-color"
                id={`btnEditComment-${index}`}
                style={{ cursor: 'pointer' }}
                onClick={() => editComment(comment)}
              />
              &nbsp;
              <em
                className="fa fa-trash far icon-hover-effect-no-color"
                id={`btnDeleteComment-${index}`}
                style={{ cursor: 'pointer' }}
                onClick={() => deleteComment(comment)}
              />
            </div>
          </div>
        </div>
      </li>
    </>
  );
};

export default CommentsTimelineCard;
